import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndPointTarget, getApiEndPoints } from '../../shared/utils';

export interface Repository {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class RepositoryService {
  private repoApiEndPoints = JSON.parse(getApiEndPoints(ApiEndPointTarget.Repository));
  
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient
  ) { }

  getRepositoryEntryProp(repositoryId: string, entryId: string): Observable<any>{
    const endpoint = this.repoApiEndPoints['entryProp'].replace("{repositoryId}", repositoryId).replace("{entryId}", entryId);
    return this.http.get<any>(endpoint);
  }

  getRepositoryEntryListing(repositoryId: string, entryId: string = "1", fieldIds: string[] = []): Observable<any>{
    const endpoint = this.repoApiEndPoints['entryListing'].replace("{repositoryId}", repositoryId).replace("{entryId}", entryId);
    let postData = {
      fieldIds: fieldIds,
      useUserConnection: true
    }
    return this.http.post<any>(endpoint, postData);
  }

  getEntryFile(repositoryId: string, entryId: string): Observable<any>{
    const endpoint = this.repoApiEndPoints['entryFile'].replace("{repositoryId}", repositoryId).replace("{entryId}", entryId);
    return this.http.get<any>(endpoint, {responseType: 'blob' as 'json', observe: 'response'});
  }

  getBulkEntries(repositoryId: string, entryIds: number[], fieldIds: string[] = []){
    const endpoint = this.repoApiEndPoints['bulkEntries'].replace("{repositoryId}", repositoryId);
    let postData = {
      fieldIds: fieldIds,
      entries: entryIds,
      useUserConnection: true
    }
    return this.http.post<any>(endpoint, postData);
  }

  getRepositoryFields(repositoryId: string): Observable<any>{
    const endpoint = this.repoApiEndPoints['fields'].replace("{repositoryId}", repositoryId);
    return this.http.get<any>(endpoint);
  }

  getAll(): Observable<Repository[]> {
    const endpoint = this.repoApiEndPoints['base'];
    return this.http.get<Repository[]>(endpoint);
  }
}
